'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = function (domain) {
  if (~process.env.REACT_APP_API_BASE_URI.indexOf('.vm')) {
    return '//' + domain + '.vm';
  }
  var server = process.env.REACT_APP_API_BASE_URI.match(/-\w+/);
  return '//' + domain + (server !== null ? server : '') + '.co.uk';
};